export default __webpack_public_path__ + "static/media/IconDesc_PipePumpMK2.256.c7d5924c.png";